(() => {
  const root = document.getElementById('cremium');
  if (!root) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // entrance
  requestAnimationFrame(() => root.classList.add('cr-ready'));

  // stars
  const sky = root.querySelector('[data-stars]');
  if (sky) {
    const n = window.innerWidth < 700 ? 38 : 80;
    let html = '';
    for (let i = 0; i < n; i++) {
      const s = Math.random() < .15 ? 3 : 2;
      html += `<i style="left:${(Math.random()*100).toFixed(2)}%;top:${(Math.random()*70).toFixed(2)}%;width:${s}px;height:${s}px;animation-delay:${(Math.random()*6).toFixed(2)}s;animation-duration:${(4+Math.random()*5).toFixed(2)}s"></i>`;
    }
    sky.innerHTML = html;
  }

  // the line: t=0 cramp (jagged), t=1 calm (soft wave)
  const N = 140;
  const jag = [];
  let seed = 7;
  const rnd = () => (seed = (seed * 9301 + 49297) % 233280) / 233280;
  for (let i = 0; i <= N; i++) {
    const x = i / N;
    let y = (rnd() - .5) * 18;
    if (i % 23 === 11) y = -78;
    if (i % 23 === 12) y = 62;
    if (i % 31 === 7) y = -48;
    if (i % 31 === 8) y = 36;
    jag.push(y);
  }
  const buildPath = (t, phase) => {
    let d = '';
    for (let i = 0; i <= N; i++) {
      const xp = i / N;
      const calm = Math.sin(xp * Math.PI * 4 + phase) * 22 * (0.35 + 0.65 * t);
      const y = 100 + jag[i] * (1 - t) + calm * t;
      d += (i ? 'L' : 'M') + (xp * 1200).toFixed(1) + ' ' + y.toFixed(1);
    }
    return d;
  };
  const heroPath = root.querySelector('[data-line="hero"]');
  const addGlow = (p) => { if (!p) return null; const g = p.cloneNode(); g.removeAttribute('data-line'); g.setAttribute('class', 'glow'); p.parentNode.insertBefore(g, p); return g; };
  const heroGlow = addGlow(heroPath);
  const setD = (p, g, d) => { p.setAttribute('d', d); if (g) g.setAttribute('d', d); };

  // hero line draw-in
  if (heroPath && !reduce) {
    heroPath.setAttribute('d', buildPath(0, 0));
    const len = heroPath.getTotalLength();
    heroPath.style.strokeDasharray = len;
    heroPath.style.strokeDashoffset = len;
    heroPath.getBoundingClientRect();
    heroPath.style.transition = 'stroke-dashoffset 1.6s cubic-bezier(.23,1,.32,1) .2s';
    requestAnimationFrame(() => { heroPath.style.strokeDashoffset = 0; });
    setTimeout(() => { heroPath.style.strokeDasharray = 'none'; heroPath.style.transition = ''; }, 2000);
    if (heroGlow) { heroGlow.style.opacity = '0'; setTimeout(() => { heroGlow.style.transition = 'opacity .8s ease'; heroGlow.style.opacity = ''; }, 1700); }
  }

  // state
  let lastFrame = 0, heroT = 0, heroTarget = 0, phase = 0, heroVisible = true, rafId = null, start = performance.now();
  const howList = root.querySelector('.how-list');
  const howFill = root.querySelector('[data-how-fill]');
  const howSteps = [...root.querySelectorAll('[data-how-step]')];
  const howMedia = [...root.querySelectorAll('[data-media]')];
  const howCount = root.querySelector('[data-how-count]');
  let howActive = 0;
  const heroEl = root.querySelector('.cr-hero');

  const fmt = (mins) => { const h = Math.floor(mins / 60), m = Math.round(mins % 60); return String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0'); };
  const ease = (x) => 1 - Math.pow(1 - x, 3);

  const onScroll = () => {
    const vh = window.innerHeight;
    if (heroEl) {
      const r = heroEl.getBoundingClientRect();
      heroTarget = Math.min(1, Math.max(0, -r.top / (r.height * .8)));
    }
    if (howList) {
      const r = howList.getBoundingClientRect();
      const line = vh * .55;
      const p = Math.min(1, Math.max(0, (line - r.top) / (r.height || 1)));
      if (howFill) howFill.style.transform = 'scaleY(' + p.toFixed(4) + ')';
      let k = 0;
      howSteps.forEach((s, i) => { if (s.getBoundingClientRect().top < line) k = i; });
      if (k !== howActive || !howSteps[k].classList.contains('is-on')) {
        howActive = k;
        howSteps.forEach((s, i) => { s.classList.toggle('is-on', i === k); s.classList.toggle('is-done', i < k); });
        howMedia.forEach((m, i) => m.classList.toggle('on', i === k));
        if (howCount) howCount.textContent = '0' + (k + 1) + ' / 0' + howSteps.length;
      }
    }
    const bar = root.querySelector('[data-bar-buy]');
    const offer = document.getElementById('comprar');
    if (bar && heroEl && offer) {
      const pastHero = heroEl.getBoundingClientRect().bottom < 0;
      const o = offer.getBoundingClientRect();
      const atOffer = o.top < vh && o.bottom > 0;
      const show = pastHero && !atOffer;
      bar.classList.toggle('show', show);
      bar.setAttribute('aria-hidden', !show);
    }
    kick();
  };

  const tick = (now) => {
    rafId = null;
    if (now - lastFrame < 32) { kick(); return; }
    lastFrame = now;
    const elapsed = (now - start) / 1000;
    // after the draw-in, the hero line starts calming by itself a little
    const auto = reduce ? 0 : Math.min(.35, Math.max(0, (elapsed - 2.2) * .12));
    const target = Math.max(auto, heroTarget);
    heroT += (target - heroT) * .08;
    phase += reduce ? 0 : .036;
    if (heroPath && heroVisible && elapsed > 1.8) setD(heroPath, heroGlow, buildPath(heroT, phase));
    if (heroVisible && !reduce) kick();
  };
  const kick = () => { if (!rafId && !document.hidden) rafId = requestAnimationFrame(tick); };

  if ('IntersectionObserver' in window) {
    const vis = new IntersectionObserver((es) => es.forEach(e => {
      if (e.target === heroEl) heroVisible = e.isIntersecting;
      kick();
    }));
    heroEl && vis.observe(heroEl);

    const io = new IntersectionObserver((es) => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -10% 0px', threshold: .12 });
    root.querySelectorAll('.reveal').forEach(el => io.observe(el));
  } else {
    root.querySelectorAll('.reveal').forEach(el => el.classList.add('is-in'));
  }

  const lineBox = root.querySelector('.cr-line');
  const clockEl = root.querySelector('.cr-clock');
  const placeLine = () => {
    if (!lineBox || !clockEl || !heroEl) return;
    const top = clockEl.getBoundingClientRect().bottom - heroEl.getBoundingClientRect().top + 6;
    lineBox.style.top = top + 'px';
  };
  placeLine();
  window.addEventListener('resize', placeLine, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeLine);
  setTimeout(placeLine, 1200);
  if (reduce && heroPath) setD(heroPath, heroGlow, buildPath(.6, 0));
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('visibilitychange', kick);
  onScroll();
  kick();

  // buy form: price in sticky bar + loading state
  const form = root.querySelector('[data-buy-form]');
  const barPrice = root.querySelector('[data-bar-price]');
  const syncBar = () => {
    const sel = form && form.querySelector('input[name="id"]:checked');
    if (sel && barPrice) barPrice.textContent = sel.dataset.name.split('·')[0].trim() + ' · ' + sel.dataset.price;
  };
  if (form) {
    form.addEventListener('change', syncBar);
    form.addEventListener('submit', () => { const b = form.querySelector('[data-buy-btn]'); if (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); } });
    syncBar();
  }
  window.addEventListener('pageshow', () => { const b = form && form.querySelector('[data-buy-btn]'); if (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); } });
})();
